/** Display only fields carried by the server market projection. */
export function marketSourceLabel(sourceId?: string | null): string {
  if (sourceId === 'mt4_bridge_ticks') return 'MT4 Collector';
  return '来源未标注';
}

export function marketQuoteStatusLabel(status?: string | null): string {
  if (status === 'fresh') return '报价新鲜';
  if (status === 'stale') return '报价延迟';
  return '报价不可用';
}

export function marketTimeLabel(timestamp?: number | null, timeframe = '1H'): string {
  if (timestamp == null || !Number.isFinite(timestamp) || timestamp <= 0) return '时间未提供';
  const date = new Date(timestamp * 1000);
  if (Number.isNaN(date.getTime())) return '时间未提供';
  if (timeframe === '1W' || timeframe === '1D') {
    return `${date.getMonth() + 1}/${date.getDate()}`;
  }
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

export function chartTimeLabels(timestamps: number[], timeframe: string): string[] {
  if (timestamps.length < 2) return [];
  if (timestamps.length < 5) {
    return [marketTimeLabel(timestamps[0], timeframe), '', '', '', marketTimeLabel(timestamps[timestamps.length - 1], timeframe)];
  }
  return Array.from({ length: 5 }, (_, index) => {
    const offset = Math.round(index * (timestamps.length - 1) / 4);
    return marketTimeLabel(timestamps[offset], timeframe);
  });
}
